import styled from 'styled-components';
const isNumber = value => typeof value === 'number';
export const toCssValue = value => isNumber(value) ? `${value}px` : value;
const gridTemplate = value => isNumber(value) ? `repeat(${value}, 1fr)` : value;
const createCssDeclaration = (property, value, valueConvert) => {
  if (value !== undefined) {
    return `${property}: ${valueConvert ? valueConvert(value) : value};`;
  }
  return undefined;
};
export const GridContainer = styled.div.withConfig({
  displayName: "GridContainer",
  componentId: "sc-1mpmh7u-0"
})(["display:grid;", " ", " ", " ", " ", " ", " ", " ", " ", ""], props => createCssDeclaration('align-content', props.$alignContent), props => createCssDeclaration('align-items', props.$alignItems), props => createCssDeclaration('gap', props.$gap, toCssValue), props => createCssDeclaration('grid-auto-flow', props.$gridAutoFlow), props => createCssDeclaration('justify-content', props.$justifyContent), props => createCssDeclaration('justify-items', props.$justifyItems), props => createCssDeclaration('margin', props.$margin, toCssValue), props => createCssDeclaration('padding', props.$padding, toCssValue), props => createCssDeclaration('place-items', props.$placeItems));
export const Columns = styled(GridContainer).withConfig({
  displayName: "Columns",
  componentId: "sc-1mpmh7u-1"
})(["grid-template-columns:", ";"], props => gridTemplate(props.$sizes));
export const Rows = styled(GridContainer).withConfig({
  displayName: "Rows",
  componentId: "sc-1mpmh7u-2"
})(["grid-template-rows:", ";"], props => gridTemplate(props.$sizes));
export const Horizontal = styled(GridContainer).attrs({
  $gridAutoFlow: 'column'
}).withConfig({
  displayName: "Horizontal",
  componentId: "sc-1mpmh7u-3"
})([""]);
export const Vertical = styled(GridContainer).attrs({
  $gridAutoFlow: 'row'
}).withConfig({
  displayName: "Vertical",
  componentId: "sc-1mpmh7u-4"
})([""]);